<template>
  
  <b-row v-if="esOncologia">
    <b-col>
      <b-card
       
        no-body
        :class="{ 'open': visibleBody }"
      >

        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGIA ONCOLOGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 0 1.5rem">

            <b-tabs card>
              <b-tab title="Preguntas" active>
                <OncologiaPreguntas/>
              </b-tab>
              <b-tab title="Escalas">
                <OncologiaEscalas/>
              </b-tab>
            </b-tabs>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import { mapState } from 'vuex';
import OncologiaPreguntas from './OncologiaPreguntas.vue';
import OncologiaEscalas   from './OncologiaEscalas.vue';

export default {
  name: "SemiologiaOncologica",

  components: {
    OncologiaPreguntas,
    OncologiaEscalas
  },

  data() {
    return {
      visibleBody: true,
    }
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    }
  },

  computed: {
    ...mapState({
      stSemOncologica: state => state.atencionCita.semiologias?.semOncologica,
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esOncologia(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000521';
    },
  },

  watch:{
    stSemOncologica: {
      deep: true,
      handler(newValue) {
        const semiologia = { tipo:'oncologica', data:newValue }
        this.$store.commit("setSemiologia", semiologia );
      }
    },

  }

}
</script>

<style>
  .checkbox-sintomas .custom-check {
    width: 100%;
  }

  .otros-check .custom-control-label{
    display: flex;
    width: 100%;
  } 
</style>